import React from "react";

import { InfoModal, ModalDivider, ModalText } from "../Controls/Modal";
import { useStore } from "../../Store";
import { Heading, List, ListItem, Text } from "@chakra-ui/react";

interface PopupProps {
  showPopup: boolean;
  handleClose: () => void;
}

export function OutsourcedProvidersPopUp({
  showPopup,
  handleClose,
}: PopupProps) {
  const { data } = useStore();

  let wording = data?.softwareProduct?.currentSoftwareProductWording;

  let consumerDataRightsPolicyUri =
    data?.softwareProduct?.dataRecipientBrand?.dataRecipient
      ?.consumerDataRightsPolicyUri;

  console.log(wording?.paragraphSupportingThirdPartiesPopup);

  function content() {
    return (
      <>
        <Text>{wording?.paragraphSupportingThirdPartiesPopup}</Text>

        <ModalDivider />

        {Boolean(wording?.softwareProductWordingThirdParties?.length) && (
          <>
            <List>
              {wording?.softwareProductWordingThirdParties?.map((t) => (
                <ListItem key={t.id}>
                  <Heading fontSize="md">{t.name}</Heading>
                  <Text>{t.description}</Text>
                  {/* <img id="DataRightLogo" src={t.} alt="Value Proposition page" /> */}
                </ListItem>
              ))}
            </List>

            <ModalDivider />
          </>
        )}

        <Heading fontSize="sm" mb={3}>
          Want more information?
        </Heading>

        <p>
          Refer to our Consumer Data Right policy for more information on
          supporting third parties.
        </p>

        <p>
          You can also request more information related to supporting third
          parties from us.
        </p>

        <p>
          <a
            href={consumerDataRightsPolicyUri}
            target="_blank"
            rel="noreferrer"
          >
            Consumer Data Right policy
          </a>
        </p>
      </>
    );
  }

  return (
    <>
      <InfoModal
        data-testid="OutsourcedProviders"
        show={showPopup}
        title="Supporting third parties"
        content={content()}
        handleOnClose={() => handleClose()}
      />
    </>
  );
}

export function DeIdentificationPopUp({ showPopup, handleClose }: PopupProps) {
  const { data } = useStore();

  let wording = data?.softwareProduct?.currentSoftwareProductWording;

  let consumerDataRightsPolicyUri =
    data?.softwareProduct?.dataRecipientBrand?.dataRecipient
      ?.consumerDataRightsPolicyUri;

  function content() {
    return (
      <>
        <ModalText text={wording?.paragraphDeIdentificationPopup} />

        <ModalDivider />

        <Heading fontSize="sm" mb={3}>
          Want more information?
        </Heading>

        <p>
          Refer to our Consumer Data Right policy for more information on data
          de-identification.
        </p>

        <p>
          <a
            href={consumerDataRightsPolicyUri}
            target="_blank"
            rel="noreferrer"
          >
            Consumer Data Right policy
          </a>
        </p>
      </>
    );
  }

  return (
    <>
      <InfoModal
        data-testid="DeIdentification"
        show={showPopup}
        title="De-identification of data"
        content={content()}
        handleOnClose={() => handleClose()}
      />
    </>
  );
}

export function DataDeletionPopUp({ showPopup, handleClose }: PopupProps) {
  const { data } = useStore();

  let wording = data?.softwareProduct?.currentSoftwareProductWording;

  let consumerDataRightsPolicyUri =
    data?.softwareProduct?.dataRecipientBrand?.dataRecipient
      ?.consumerDataRightsPolicyUri;

  function content() {
    return (
      <>
        <ModalText text={wording?.paragraphDataDeletionPopup} />

        <ModalDivider />

        <Heading fontSize="sm" mb={3}>
          Want more information?
        </Heading>

        <p>
          Refer to our Consumer Data Right policy for more information on data
          deletion.
        </p>

        <p>
          <a
            href={consumerDataRightsPolicyUri}
            target="_blank"
            rel="noreferrer"
          >
            Consumer Data Right policy
          </a>
        </p>
      </>
    );
  }

  return (
    <>
      <InfoModal
        data-testid="DataDeletion"
        show={showPopup}
        title="Data deletion"
        content={content()}
        handleOnClose={() => handleClose()}
      />
    </>
  );
}

export function JointAccountPopUp({ showPopup, handleClose }: PopupProps) {
  function content() {
    return (
      <>
        <p>
          You have not consented via Joint Account Management Setup (JAMS) to
          allow data to be shared.
        </p>

        <p>
          Please sign into Online Banking and visit Options {"->"} Joint Account
          Management to complete setup.
        </p>
      </>
    );
  }

  return (
    <>
      <InfoModal
        data-testid="JointAccount"
        show={showPopup}
        title="Joint account managment not setup"
        content={content()}
        handleOnClose={() => handleClose()}
      />
    </>
  );
}

export function ClosedAccountPopUp({ showPopup, handleClose }: PopupProps) {
  function content() {
    return (
      <>
        <p>Closed Accounts are not currently available to share.</p>

        <p>We will notify you when we have completed this work.</p>
      </>
    );
  }

  return (
    <>
      <InfoModal
        data-testid="JointAccount"
        show={showPopup}
        title="Closed accounts are not currently able to be shared"
        content={content()}
        handleOnClose={() => handleClose()}
      />
    </>
  );
}
